const routes = {
    LOGIN: "/login",
    LOGIN_WITH_SSO: "/loginWithSso",
    SELECT_SITE: "/select",
    CAPTURE_PHOTO: "/capture-photo",
    SHIFT_FOUND: "/shift-found",
    AUTH0_CALLBACK: "/auth0/callback"
}

export default routes
